// Match the assigned App permission, not a role name or the CRM equivalent.
export const canManageCheckInPoint = (user) => Array.isArray(user?.role?.permissions) &&
    user.role.permissions.some((permission) => permission?.panel === "app" &&
        permission.type === "exhibition_event" && permission.value === "checkin_point");
